<template>
<div>
	<el-upload
		action="www"
		:drag="drag"
		class="form-item-upload"
		:http-request="httpRequest"
		:on-success="handleSuccess"
    :on-error="handleError"
		:file-list="fileList"
		:before-upload="beforeUpload"
		:on-remove="handleRemove"
		:multiple="multiple"
		:accept="accept"
		:show-file-list="fileListShow"
	>
		<slot />
	</el-upload>
  <!-- 进度条 -->
  <div v-if="progress.visible" style="z-index:9999;width: 100%;height: 100%;position: fixed;left: 0;top: 0;background: rgba(74, 74, 74, 0.4)" @click.stop>
    <div _pos="fixed" _z="2009" style="top:50%;left:50%;transform: translate(-50%, -50%);z-index:4000" _w="250px">
      <div _text="20px [#ff5e2a] bolder" _m="b-10px"><i class="el-icon-loading" _m="r-5px"/>{{ progress.msg }}</div>
      <el-progress :percentage="Number(progress.num)" _h="40px" :stroke-width="18" :text-inside="true"></el-progress>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios'
import MediaInfoFactory from 'mediainfo.js'
import CryptoJS from 'crypto-js'

export default {
	props: {
		drag: {
			type: Boolean,
			default: false
		},
		echoFile: Array,
		fileListShow: {
			type: Boolean,
			default: true
		},
		multiple: {
			type: Boolean,
			default: false
		},
		accept: {
			type: String,
			default: ''
		},
		fileUrlData: {
			type: [Array, Object]
		},
		customUpload: Function,
		deleteUpload: Function
	},
	data() {
		return {
			fileList: [],
      analysis: '',
      progress: {
        num: 0,
        visible: false,
        msg: '正在上传中...'
      },
      progressTimer: null
		}
	},
	watch: {
		echoFile: {
			handler() {
				if (this.echoFile?.length > 0) {
					this.echoFile?.forEach(item => {
						this.addImageUrl(item)
					})
				}
			}
		},
    progress: {
      handler(vla) {
        if (vla.visible) {
          this.progressTimer = setInterval(() => {
            if (vla.num >= 99) {
              clearInterval(this.progressTimer)
            } else {
              vla.num += 1
            }
          }, 1000)
        } else {
          vla.num = 99
          clearInterval(this.progressTimer)
        }
      },
      deep: true
    }
	},
  destroyed() {
    if (this.progressTimer) {
      clearInterval(this.progressTimer)
    }
  },
	methods: {
		addImageUrl(url) {
			// const filename = url.split('/')?.pop() || '*'; // 从 URL 中获取文件名
			const blobUrl = URL.createObjectURL(new Blob([''], { type: '' })) // 创建一个 Blob 对象并获取 URL
			const file = { name: url, url: blobUrl }
			this.fileList.push(file) // 添加到文件列表中
		},
		// changeFileAccept(type) {
		// 	let image = 'image/jpg, image/bmp, image/gif, image/png, image/jpeg'
		// 	let video = 'video/MP4, video/MPG; video/MPEG'
		// 	let audio = 'audio/MP3'
		// 	let accept
		// 	switch (type) {
		// 		case 'image':
		// 			accept = image
		// 			break
		// 		case 'video':
		// 			accept = video
		// 			break
		// 		case 'audio':
		// 			accept = audio
		// 			break
		// 		default:
		// 			accept = `${image},${video},${audio}`
		// 	}
		// 	return accept
		// },
		beforeUpload(file) {
			// const type = fileType(file)
			let fileType = file.type.split('/')[1]
			const accept = this.accept.split('/')[0]
      if (fileType == 'x-ms-wmv') {
        this.analysis = fileType = 'wmv'
      }
      // if (file.size / 1024 / 1024 > 100) {
      //   this.$message.error(`文件最大支持100M`)
      //   return false
      // }
			if (accept.indexOf(fileType) != -1) return true
			else {
				this.$message.error(`文件格式不正确`)
				return false
			}
		},
    fetchHash(data) {
      const blockSize = 1024 * 1024 * 10
      let wordArray
      const hash = CryptoJS.algo.MD5.create()
      for (let i = 0; i < data.byteLength; i += blockSize) {
        const end = Math.min(i + blockSize, data.byteLength)
        const chunk = data.slice(i, end)
        wordArray = CryptoJS.lib.WordArray.create(Array.from(new Uint8Array(chunk)))
        hash.update(wordArray)
      }
      return hash.finalize().toString()
    },
		readBlobAsArrayBuffer(file) {
			return new Promise(resolve => {
				const reader = new window.FileReader()
				reader.onload = event => resolve(event.target.result)
				reader.readAsArrayBuffer(file)
			})
		},
		async httpRequest(file) {
      this.progress.num = 0
      this.progress.visible = true
      if (this.analysis == 'wmv') {
        // 检测文件格式
        console.log(MediaInfoFactory)
        // const info = await MediaInfoFactory().then(mediainfo => {
        //   return mediainfo.analyzeData(() => file.size, (chunkSize, offset) => {
        //     return new Promise((resolve, reject) => {
        //       const reader = new FileReader()
        //       reader.onload = () => resolve(new Uint8Array(reader.result))
        //       reader.onerror = () => reject('解析失败')
        //       reader.readAsArrayBuffer(file.slice(offset, offset + chunkSize))
        //     })
        //   })
        // })
        // if (info.media?.track.find(v => v['@type'] === 'Video')?.Format !== 'AVC') {
        const isLocal = await Promise.race([
          new Promise((resolve) => setTimeout(() => resolve(false), 1000)),
          axios
            .get('http://127.0.0.1:5407/api/ffmpeg/ping')
            .then((_) => true)
            .catch((_) => false),
          ])
        console.log('isLocal', isLocal)
        if (isLocal) {
          const form = new FormData()
          form.append('file', file.file)
          const upload = await axios.post('http://127.0.0.1:5407/api/ffmpeg/upload', form).catch((_) => false)
          const ret = await axios
            .get('http://127.0.0.1:5407/api/ffmpeg/format_conversion', {
              params: { file_name: upload.data },
            })
            .catch((_) => false)
          if (typeof ret === 'boolean' || ret.data.code !== 0) return this.$message.error('视频解析失败！')
          const blolRet = await axios.get(ret.data.url, { responseType: 'blob' }).catch((_) => false)
          if (typeof blolRet === 'boolean') {
            this.$message.error('文件读取失败！')
            return
          }
          let rf = await this.readBlobAsArrayBuffer(blolRet.data)
          const MD5 = this.fetchHash(rf)
          const data = await this.$api3.question_set.upload({
            file_key: 'file',
            filename: file.file.name,
            hash: MD5,
            mime_type: blolRet.data.type,
            size: blolRet.data.size,
            storage: {
              channel: 'public'
            }
          })
          let fileUrl
          if (blolRet.data.size / 1024 / 1024 > 2000) {
            let form = new FormData()
            form.append('file', file.file)
            fileUrl = await this.$api3.question_set.uploadFileForm(data.uri, form, {
              ...data.headers
            })
          } else {
            fileUrl = await this.$api3.question_set.uploadFile(data.uri, rf, {
              ...data.headers
            })
          }
          return fileUrl
        } else {
          this.$message.error('文件格式不支持！')
          return
        }
        // }
      } else {
        let rf = await this.readBlobAsArrayBuffer(file.file)
        const MD5 = this.fetchHash(rf)
        const data = await this.$api3.question_set.upload({
          file_key: 'file',
          filename: file.file.name,
          hash: MD5,
          mime_type: file.file.type,
          size: file.file.size,
          storage: {
            channel: 'public'
          }
        })
        let fileUrl
        if (file.file.size / 1024 / 1024 > 2000) {
          let form = new FormData()
          form.append('file', file.file)
          fileUrl = await this.$api3.question_set.uploadFileForm(data.uri, form, {
            ...data.headers
          })
        } else {
          fileUrl = await this.$api3.question_set.uploadFile(data.uri, rf, {
            ...data.headers
          })
        }
        return fileUrl
      }
		},
		async handleSuccess(response, file, fileList) {
      this.progress.num = 100
			this.fileList = [...this.fileList, file]
			if (this.customUpload) {
				this.customUpload({ response, fileType: file.raw.type.split('/')[0], fileUrlData: this.fileUrlData })
			} else {
				this.$emit('customUpload', { response, fileType: file.raw.type.split('/')[0], fileUrlData: this.fileUrlData })
			}
      await new Promise(resolve => setTimeout(resolve, 500))
      this.progress.visible = false
		},
    handleError() {
      this.progress.visible = false
    },
		handleRemove(file, fileList) {
			const index = this.fileList.findIndex(item => item.uid === file.uid)
			console.log(index, file, fileList)
			this.fileList = fileList
			this.deleteUpload({ index, fileUrlData: this.fileUrlData })
		}
	}
}
</script>
<style lang="scss">
.form-item-upload {
	width: 200px;
}
</style>
